import { useEffect, useCallback } from 'react';
import { useDialogClose } from '../hooks/useDialogClose';

interface ImagePreviewModalProps {
  url: string;
  filename: string;
  onClose: () => void;
}

export function ImagePreviewModal({ url, filename, onClose }: ImagePreviewModalProps) {
  const { isClosing, handleClose } = useDialogClose(onClose);

  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Escape') handleClose();
  }, [handleClose]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return (
    <div className={`image-preview-overlay${isClosing ? ' overlay-closing' : ''}`} onClick={handleClose}>
      <div
        className={`image-preview-modal${isClosing ? ' dialog-closing' : ''}`}
        role="dialog"
        aria-label={`Preview: ${filename}`}
        onClick={e => e.stopPropagation()}
      >
        <div className="image-preview-header">
          <span className="image-preview-title">{filename}</span>
          <button className="image-preview-close" onClick={handleClose} aria-label="Close">×</button>
        </div>
        <div className="image-preview-body">
          <img src={url} alt={filename} className="image-preview-full" />
        </div>
      </div>
    </div>
  );
}
